import { render, staticRenderFns } from "./informacion_general.vue?vue&type=template&id=2e9a0288"
import script from "./informacion_general.vue?vue&type=script&lang=js"
export * from "./informacion_general.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports